(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('CompanyDeleteController',CompanyDeleteController);

    CompanyDeleteController.$inject = ['$rootScope','$uibModalInstance', 'entity', 'Company'];

    function CompanyDeleteController($rootScope,$uibModalInstance, entity, Company) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Company.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    $rootScope.resetCompany();
                });
        }
    }
})();
